import Text, { TEXT_VARIANT } from '@pixum/text';
import { Image, IMAGE_LOADING } from 'components';
import type { ContactHeaderProps } from './types';
import styles from './ContactHeader.module.css';

export function ContactHeader({ subtitle, logo, device }: ContactHeaderProps) {
  return (
    <div className={styles.header}>
      <Text className={styles.subheadline} variant={TEXT_VARIANT.SUBHEADLINE}>
        {subtitle}
      </Text>
      {!!logo && (
        <Image className={styles.image} device={device} image={logo} loading={IMAGE_LOADING.LAZY} />
      )}
    </div>
  );
}
